import { Grid, FormControlLabel, Switch } from "@material-ui/core";
import { useContext } from "react";
import TextField from "../../../../components/basics/TextFieldErp";
import { TemplateContractsContext } from "../contexts/ContractsContext";
import Fieldset from "../../../../components/basics/Fieldset";
import { HeaderAccordion } from "../styles/ModalContracts";
import Chip from "../../../../components/basics/Chip";
import { Line } from "../styles/ModalContracts";

const AcordionContractsGeral = ({ location }) => {
  const {
    setContractDescription,
    contractDescription,
    active,
    setActive,
    errorsSubmit,
  } = useContext(TemplateContractsContext);

  return (
    <>
      <Fieldset
        titulo={
          <HeaderAccordion>
            <Grid container spacing={2}>
              <Grid item xs>
                <Chip
                  label="DADOS GERAIS"
                  bgcolor="primary"
                  textcolor="white"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded
      >
        <Line container>
          <Grid
            container
            xs={12}
            alignItems="left"
            justifyContent="space-around"
            spacing={3}
          >
            <Grid item xs={6} alignContent="center">
              <TextField
                label="Descrição*"
                type="text"
                size="small"
                setValue={setContractDescription}
                value={contractDescription}
                error={errorsSubmit.description ? true : false}
                helperText={errorsSubmit.description || ""}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                label="Ativo"
                value="end"
                control={
                  <Switch
                    checked={active}
                    onChange={() => {
                      setActive((current) => !current);
                    }}
                    color="primary"
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                  />
                }
              />
            </Grid>
          </Grid>
        </Line>
      </Fieldset>
    </>
  );
};

export default AcordionContractsGeral;
